/* -----------------Helpers--------------- */
import { getRemarkPlugins } from "@/plugins";
import { type EvaluateOptions, evaluate } from "@mdx-js/mdx";

/* -----------------Globals--------------- */
// biome-ignore  lint/style/noNamespaceImport: This is a valid import
import * as runtime from "react/jsx-runtime";

export type MDXProps = {
	value: string;
	components?: Record<
		string,
		React.ComponentType<{ children?: React.ReactNode }>
	>;
};

export const MDX = async ({ value, components = {} }: MDXProps) => {
	if (!value) {
		return null;
	}

	const { default: MDXContent } = await evaluate(value, {
		...runtime,
		remarkPlugins: getRemarkPlugins(),
	} as EvaluateOptions);

	return <MDXContent components={components} />;
};
